export default {
  title: 'Allergeni',
  description: 'Si avvisa che questo {{product}} potrebbe contenere i seguenti ingredienti o loro derivati:',
  options: {
    dairy: 'Latticini/Latte',
    eggs: 'Uova',
    fish: 'Pesce',
    gluten: 'Glutine',
    mango: 'Mango',
    peanuts: 'Arachidi',
    sesame: 'Sesamo',
    shellfish: 'Frutti di Mare',
    soy: 'Soia',
    tree_nuts: 'Frutta a Guscio',
    celery: 'Sedano',
    crustaceans: 'Crostacei',
    lupin: 'Lupino',
    molluscs: 'Molluschi',
    mustard: 'Senape',
    nuts: 'Frutta Secca',
    sulphites: 'Solfiti',
    almonds: 'Mandorle',
    barley: 'Orzo',
    brazil_nuts: 'Noci del Brasile',
    cashew: 'Anacardi',
    hazelnuts: 'Nocciole',
    kamut: 'Kamut',
    macadamia: 'Noci di Macadamia',
    oats: 'Avena',
    pecan: 'Noci Pecan',
    pistachios: 'Pistacchi',
    rye: 'Segale',
    spelt: 'Farro',
    walnuts: 'Noci',
    wheat: 'Frumento',
    sugared_drink: 'Bevanda Zuccherata',
    lentils: 'Lenticchie',
    queensland_nuts: 'Noci del Queensland',
  },
};
